export const TRANSLATIONS = {
  fr: {
    common: {
      currency: 'DH', addToBag: 'Ajouter au panier', added: 'Ajouté au panier',
      viewAll: 'Tout voir', new: 'Nouveauté', signature: 'Signature',
      remove: 'Retirer', close: 'Fermer', menu: 'Menu',
      placeholderLabel: 'Photographie à venir',
      placeholderNote: 'Zone réservée à la photographie officielle',
      loading: 'Chargement…', free: 'Offerte', back: 'Retour',
      continueShopping: 'Continuer mes achats', qty: 'Quantité', size: 'Taille', color: 'Couleur',
    },
    nav: { home: 'Accueil', shop: 'Boutique', about: 'À propos', contact: 'Contact', bag: 'Panier' },
    announce: 'Livraison offerte dès 600 DH · Paiement à la livraison partout au Maroc',
    hero: {
      eyebrow: 'Nouvelle collection',
      line1: 'L’élégance,',
      line2: 'doucement.',
      sub: 'Des pièces féminines au tombé délicat, pensées pour durer — robes, mailles et soies dans une palette apaisée.',
      cta1: 'Découvrir la collection', cta2: 'Voir les nouveautés',
      phLabel: 'Campagne — photographie à venir', caption: 'Édition 01 — Les Essentiels', scroll: 'Défiler',
    },
    home: {
      newCollection: { eyebrow: 'La sélection', title: 'Nouvelle collection', sub: 'Quatre pièces pour ouvrir la saison, dans les tons de la maison.', cta: 'Voir la boutique' },
      categories: { eyebrow: 'Explorer', title: 'Par catégorie' },
      newIn: { eyebrow: 'Arrivages', title: 'Nouveautés', cta: 'Tout voir' },
      editorial: {
        eyebrow: 'Le journal', title: 'Le rituel de l’habillage',
        p1: 'Chez MIORA, une pièce se choisit comme on choisit un silence : avec attention. Nos matières sont pensées au toucher, nos coupes au mouvement.',
        p2: 'Chaque collection s’écrit lentement, dans une palette qui apaise — et se porte encore plus lentement.',
        cta: 'Lire notre histoire', phLabel: 'Éditorial — photographie à venir', caption: 'Rituels — Édition 02',
      },
      statement: { quote: 'Le luxe n’est pas bruyant. Il se reconnaît au calme qu’il laisse.', author: 'MIORA' },
      instagram: { eyebrow: '@mioraboutique_', title: 'Suivez la maison', sub: 'Des aperçus d’atelier, des arrivages, des dessins jamais publiés.', cta: 'Ouvrir Instagram', phLabel: 'Instagram — visuels à venir' },
      newsletter: { title: 'Recevez nos nouvelles', sub: 'Les arrivages et les éditions limitées, rien de plus. Pas de bruit.', ph: 'Votre adresse e-mail', cta: 'S’inscrire', ok: 'Merci — vous êtes inscrite.', err: 'Une erreur est survenue. Réessayez.' },
    },
    shop: {
      title: 'La boutique', sub: 'Chaque pièce, à sa façon : choisissez, comparez, essayez.',
      count: 'pièces', filters: 'Filtres', clearAll: 'Tout effacer',
      category: 'Catégorie', size: 'Taille', color: 'Couleur', price: 'Prix', collection: 'Collection',
      maxPrice: 'Prix maximum', sortBy: 'Trier par', sortNew: 'Nouveautés', sortPriceAsc: 'Prix croissant', sortPriceDesc: 'Prix décroissant',
      empty: 'Aucune pièce ne correspond à ces filtres.', emptyCta: 'Réinitialiser les filtres',
      openFilters: 'Filtrer', apply: 'Voir les résultats',
    },
    product: {
      description: 'Description', details: 'Détails & matière', shippingInfo: 'Livraison & retours',
      chooseSize: 'Choisissez votre taille', alsoLike: 'Vous aimerez aussi', selectSizeFirst: 'Choisissez d’abord une taille',
      notFound: 'Pièce introuvable.', backToShop: 'Retour à la boutique',
      shippingBody: 'Livraison standard 40 DH, offerte dès 600 DH — délais indicatifs de 2 à 4 jours ouvrables. Retours acceptés sous 7 jours, pièce non portée.',
      careBody: 'Lavage délicat à froid, à l’envers. Fer doux sur l’envers. La douceur dure quand on la traite bien.',
    },
    bag: {
      title: 'Panier', empty: 'Votre panier est vide',
      emptySub: 'Il attend sa première pièce — les nouveautés viennent d’arriver.',
      ctaShop: 'Découvrir la boutique', subtotal: 'Sous-total', shipping: 'Livraison', total: 'Total',
      checkout: 'Passer commande', note: 'Paiement à la livraison disponible partout au Maroc.',
      freeNote: 'Plus que {x} pour la livraison offerte.',
    },
    checkout: {
      title: 'Commande', sub: 'Cinq étapes tranquilles, aucun compte requis.',
      stepContact: 'Contact', stepShipping: 'Adresse', stepDelivery: 'Livraison', stepPayment: 'Paiement', stepSummary: 'Récapitulatif',
      f_name: 'Prénom et nom', f_email: 'E-mail', f_phone: 'Téléphone', f_address: 'Adresse', f_city: 'Ville', f_postal: 'Code postal',
      deliveryTitle: 'Mode de livraison', standard: 'Standard', standardTime: '2 à 4 jours ouvrables', standardDesc: '40 DH — offerte dès 600 DH. Délai indicatif.',
      express: 'Express', expressTime: '24 à 48 heures', expressDesc: '90 DH, partout au Maroc. Délai indicatif.',
      paymentTitle: 'Mode de paiement', cod: 'Paiement à la livraison', codDesc: 'Payez en espèces à la réception, sans frais.',
      transfer: 'Virement bancaire', transferDesc: 'Nos coordonnées bancaires vous seront envoyées par e-mail après la commande.',
      summaryTitle: 'Récapitulatif', placeOrder: 'Confirmer la commande', sending: 'Envoi…',
      successTitle: 'Merci.', successSub: 'Votre commande {n} est confirmée. Un e-mail récapitulatif arrive.',
      successNote: 'Ceci est une démonstration — aucune somme n’a été encaissée.',
      backToShop: 'Retour à la boutique', errRequired: 'Merci de remplir ce champ.', edit: 'Modifier',
      emptyBag: 'Votre panier est vide — ajoutez une pièce avant de commander.',
    },
    about: {
      eyebrow: 'La maison', title: 'MIORA, l’élégance douce',
      lead: 'Une maison de mode féminine, née d’une conviction : la douceur est une forme de force.',
      s1Title: 'Notre idée', s1: 'MIORA choisit des pièces qui ne crient jamais — des coupes justes, des matières délicates, une palette qui rappelle la terre et la rosée. Pas de saisons bruyantes, des pièces qui restent.',
      s2Title: 'Nos matières', s2: 'Soies lavées, crêpes fluides, mailles serrées : chaque matière est choisie au toucher, puis portée des semaines avant d’être validée.',
      s3Title: 'Notre promesse', s3: 'Des petites séries, des prix justes, et un service qui vous répond comme une amie — en français, en anglais, en arabe.',
      quote: '« Nous ne voulons pas habiller tout le monde. Nous voulons habiller celles qui aiment le calme. »',
      valuesTitle: 'Ce qui nous guide', v1t: 'Douceur', v1d: 'Des matières et des couleurs qui apaisent, jamais qui fatiguent.',
      v2t: 'Justesse', v2d: 'Des coupes pensées pour les corps réels, validées par des essayages réels.',
      v3t: 'Discrétion', v3d: 'Le détail se découvre à force de regarder — jamais au premier regard.',
      phLabel: 'La maison — photographie à venir', phLabel2: 'Atelier — photographie à venir',
    },
    contact: {
      title: 'Écrivez-nous', sub: 'Une question sur une taille, une commande, un retour ? Nous répondons vite, et simplement.',
      name: 'Nom', email: 'E-mail', subject: 'Sujet', message: 'Message', send: 'Envoyer le message', ok: 'Message envoyé — merci.', err: 'Une erreur est survenue. Réessayez.',
      csTitle: 'Service client', emailLabel: 'bonjour@miora-boutique.com', hoursLabel: 'Horaires', hoursValue: 'Lun – Sam, 9 h – 18 h',
      responseNote: '(horaires indicatifs — à confirmer)', socialLabel: 'Réseaux',
    },
    size: {
      title: 'Guide des tailles', sub: 'Mensurations en centimètres, prises à plat.',
      colSize: 'Taille', colBust: 'Tour de poitrine', colWaist: 'Tour de taille', colHip: 'Tour de hanches',
      howTitle: 'Comment se mesurer', how1: 'Poitrine : au point le plus fort, ruban bien horizontal.',
      how2: 'Taille : au point le plus creux, sans serrer.', how3: 'Hanches : au point le plus fort, pieds joints.',
      noteTitle: 'Entre deux tailles ?', note: 'Prenez la plus grande — nos coupes n’auront que plus d’allure. Les mailles, elles, se portent avec une aisance légère.',
      fitNote: 'Mensurations indicatives — chaque fiche produit précise les tailles disponibles.',
    },
    faq: {
      title: 'Questions fréquentes', sub: 'L’essentiel, en peu de mots.',
      cats: { orders: 'Commandes', shipping: 'Livraison', returns: 'Retours', sizing: 'Tailles', payment: 'Paiement', products: 'Produits' },
      items: {
        orders: [
          { q: 'Comment passer commande ?', a: 'Ajoutez vos pièces au panier, puis suivez les étapes : contact, adresse, livraison, paiement. Aucun compte n’est requis.' },
          { q: 'Puis-je modifier ma commande ?', a: 'Si elle n’a pas encore été préparée, écrivez-nous aussitôt — nous ferons le possible.' },
        ],
        shipping: [
          { q: 'Où livrez-vous ?', a: 'Partout au Maroc. Les délais affichés à la commande sont indicatifs et confirmés par e-mail.' },
          { q: 'Quels sont les frais de livraison ?', a: '40 DH en standard, offerte dès 600 DH d’achat. Livraison express à 90 DH. Délais indicatifs.' },
        ],
        returns: [
          { q: 'Comment retourner une pièce ?', a: 'Vous disposez de 7 jours après réception. La pièce doit être non portée, avec ses étiquettes — voir la page Retours.' },
          { q: 'Les retours sont-ils payants ?', a: 'Les frais de retour restent à votre charge, sauf article défectueux — échange alors offert.' },
        ],
        sizing: [
          { q: 'Comment choisir ma taille ?', a: 'Consultez le guide des tailles : mensurations détaillées et conseils. Entre deux tailles, prenez la plus grande.' },
          { q: 'Vos coupes taillent-elles normalement ?', a: 'Nos coupes sont fidèles au guide ; les mailles se portent avec une aisance légère.' },
        ],
        payment: [
          { q: 'Puis-je payer à la livraison ?', a: 'Oui — le paiement à la livraison est disponible partout au Maroc, sans frais supplémentaires.' },
          { q: 'Proposez-vous le paiement en ligne ?', a: 'Pas encore. Pour l’instant : paiement à la livraison ou virement bancaire (coordonnées envoyées après commande).' },
        ],
        products: [
          { q: 'D’où viennent vos matières ?', a: 'Nos matières sont sélectionnées pièce par pièce ; chaque fiche produit détaille la composition exacte.' },
          { q: 'Les pièces sont-elles toutes en stock ?', a: 'Chaque fiche indique les tailles disponibles ; le stock est mis à jour à chaque commande.' },
        ],
      },
    },
    ship: {
      title: 'Livraison', intro: 'Nous livrons partout au Maroc, avec le même soin que pour la confection d’une pièce.',
      t1Title: 'Délais', t1Body: 'Livraison standard : 2 à 4 jours ouvrables. Livraison express : 24 à 48 heures.',
      t2Title: 'Frais', t2Body: 'Standard : 40 DH — offerte dès 600 DH d’achat. Express : 90 DH, quelle que soit la commande.',
      t3Title: 'Suivi', t3Body: 'Un lien de suivi vous est envoyé dès l’expédition, par e-mail.',
      placeholder: 'Délai indicatif — à confirmer',
    },
    returns: {
      title: 'Retours & échanges', intro: 'Une pièce qui ne convient pas ne doit jamais devenir un souci.',
      r1Title: 'Délai', r1Body: 'Vous disposez de 7 jours après réception pour demander un retour ou un échange.',
      r2Title: 'Conditions', r2Body: 'La pièce doit être non portée, non lavée, avec ses étiquettes d’origine.',
      r3Title: 'Remboursement', r3Body: 'Une fois la pièce reçue et contrôlée, le remboursement part sous 5 jours ouvrables.',
      exchTitle: 'Échanges', exchBody: 'Taille à changer ? Écrivez-nous — l’échange part dès réception de la première pièce.',
      noteTitle: 'Article défectueux ?', noteBody: 'Retour entièrement offert, échange prioritaire.',
      placeholder: 'Délai indicatif — à confirmer',
    },
    footer: {
      shopCol: 'Boutique', helpCol: 'Aide', houseCol: 'La maison', tagline: 'L’élégance douce, partout au Maroc.',
      rights: '© MIORA Boutique — miora-boutique.com. Tous droits réservés.',
      paymentNote: 'Paiement à la livraison · Virement bancaire',
    },
    notFound: { title: 'Page introuvable', sub: 'Le lien a peut-être changé — la boutique, elle, est toujours là.', cta: 'Retour à l’accueil' },
  },

  en: {
    common: {
      currency: 'DH', addToBag: 'Add to bag', added: 'Added to bag',
      viewAll: 'View all', new: 'New', signature: 'Signature',
      remove: 'Remove', close: 'Close', menu: 'Menu',
      placeholderLabel: 'Photography to come',
      placeholderNote: 'Reserved for official campaign photography',
      loading: 'Loading…', free: 'Free', back: 'Back',
      continueShopping: 'Continue shopping', qty: 'Quantity', size: 'Size', color: 'Color',
    },
    nav: { home: 'Home', shop: 'Shop', about: 'About', contact: 'Contact', bag: 'Bag' },
    announce: 'Free delivery over 600 DH · Cash on delivery across Morocco',
    hero: {
      eyebrow: 'New collection',
      line1: 'Elegance,',
      line2: 'softly.',
      sub: 'Feminine pieces with a delicate drape, made to last — dresses, knits and silks in a calming palette.',
      cta1: 'Discover the collection', cta2: 'Shop new arrivals',
      phLabel: 'Campaign — photography to come', caption: 'Edition 01 — The Essentials', scroll: 'Scroll',
    },
    home: {
      newCollection: { eyebrow: 'The edit', title: 'New collection', sub: 'Four pieces to open the season, in the house’s tones.', cta: 'Visit the shop' },
      categories: { eyebrow: 'Explore', title: 'By category' },
      newIn: { eyebrow: 'Just arrived', title: 'New in', cta: 'View all' },
      editorial: {
        eyebrow: 'The journal', title: 'The ritual of dressing',
        p1: 'At MIORA, a piece is chosen the way one chooses silence: with attention. Our materials are thought through by touch, our cuts by movement.',
        p2: 'Every collection is written slowly, in a palette that calms — and is worn even more slowly.',
        cta: 'Read our story', phLabel: 'Editorial — photography to come', caption: 'Rituals — Edition 02',
      },
      statement: { quote: 'Luxury is not loud. It is recognised by the calm it leaves behind.', author: 'MIORA' },
      instagram: { eyebrow: '@mioraboutique_', title: 'Follow the house', sub: 'Studio glimpses, new arrivals, sketches never published.', cta: 'Open Instagram', phLabel: 'Instagram — visuals to come' },
      newsletter: { title: 'Hear from us', sub: 'New arrivals and limited editions, nothing more. No noise.', ph: 'Your e-mail address', cta: 'Subscribe', ok: 'Thank you — you’re on the list.', err: 'Something went wrong. Please try again.' },
    },
    shop: {
      title: 'The shop', sub: 'Each piece, its own way: choose, compare, try.',
      count: 'pieces', filters: 'Filters', clearAll: 'Clear all',
      category: 'Category', size: 'Size', color: 'Color', price: 'Price', collection: 'Collection',
      maxPrice: 'Maximum price', sortBy: 'Sort by', sortNew: 'New arrivals', sortPriceAsc: 'Price ascending', sortPriceDesc: 'Price descending',
      empty: 'No piece matches these filters.', emptyCta: 'Reset filters',
      openFilters: 'Filters', apply: 'See results',
    },
    product: {
      description: 'Description', details: 'Details & fabric', shippingInfo: 'Shipping & returns',
      chooseSize: 'Choose your size', alsoLike: 'You may also like', selectSizeFirst: 'Choose a size first',
      notFound: 'Piece not found.', backToShop: 'Back to the shop',
      shippingBody: 'Standard delivery 40 DH, free over 600 DH — indicative 2 to 4 business days. Returns accepted within 7 days, unworn.',
      careBody: 'Delicate cold wash, inside out. Gentle iron on the reverse. Softness lasts when treated well.',
    },
    bag: {
      title: 'Bag', empty: 'Your bag is empty',
      emptySub: 'It is waiting for its first piece — the new arrivals have landed.',
      ctaShop: 'Discover the shop', subtotal: 'Subtotal', shipping: 'Delivery', total: 'Total',
      checkout: 'Checkout', note: 'Cash on delivery available across Morocco.',
      freeNote: '{x} away from free delivery.',
    },
    checkout: {
      title: 'Checkout', sub: 'Five calm steps, no account required.',
      stepContact: 'Contact', stepShipping: 'Address', stepDelivery: 'Delivery', stepPayment: 'Payment', stepSummary: 'Summary',
      f_name: 'Full name', f_email: 'E-mail', f_phone: 'Phone', f_address: 'Address', f_city: 'City', f_postal: 'Postal code',
      deliveryTitle: 'Delivery method', standard: 'Standard', standardTime: '2 to 4 business days', standardDesc: '40 DH — free over 600 DH. Indicative timing.',
      express: 'Express', expressTime: '24 to 48 hours', expressDesc: '90 DH, anywhere in Morocco. Indicative timing.',
      paymentTitle: 'Payment method', cod: 'Cash on delivery', codDesc: 'Pay in cash on receipt, no fees.',
      transfer: 'Bank transfer', transferDesc: 'Our bank details will be e-mailed to you after the order.',
      summaryTitle: 'Summary', placeOrder: 'Confirm order', sending: 'Sending…',
      successTitle: 'Thank you.', successSub: 'Your order {n} is confirmed. A recap e-mail is on its way.',
      successNote: 'This is a demonstration — no amount has been charged.',
      backToShop: 'Back to the shop', errRequired: 'Please fill in this field.', edit: 'Edit',
      emptyBag: 'Your bag is empty — add a piece before checking out.',
    },
    about: {
      eyebrow: 'The house', title: 'MIORA, soft elegance',
      lead: 'A women’s fashion house born of one conviction: softness is a form of strength.',
      s1Title: 'Our idea', s1: 'MIORA chooses pieces that never shout — precise cuts, delicate materials, a palette that recalls earth and dew. No loud seasons, only pieces that stay.',
      s2Title: 'Our materials', s2: 'Washed silks, fluid crêpes, close knits: every material is chosen by touch, then worn for weeks before it is approved.',
      s3Title: 'Our promise', s3: 'Small runs, fair prices, and a service that answers like a friend — in French, English and Arabic.',
      quote: '“We do not want to dress everyone. We want to dress the women who love calm.”',
      valuesTitle: 'What guides us', v1t: 'Softness', v1d: 'Materials and colours that soothe, never tire.',
      v2t: 'Precision', v2d: 'Cuts designed for real bodies, validated by real fittings.',
      v3t: 'Discretion', v3d: 'The detail reveals itself as you keep looking — never at first glance.',
      phLabel: 'The house — photography to come', phLabel2: 'Studio — photography to come',
    },
    contact: {
      title: 'Write to us', sub: 'A question about a size, an order, a return? We answer quickly, and simply.',
      name: 'Name', email: 'E-mail', subject: 'Subject', message: 'Message', send: 'Send message', ok: 'Message sent — thank you.', err: 'Something went wrong. Please try again.',
      csTitle: 'Customer service', emailLabel: 'bonjour@miora-boutique.com', hoursLabel: 'Hours', hoursValue: 'Mon – Sat, 9 am – 6 pm',
      responseNote: '(indicative hours — to be confirmed)', socialLabel: 'Social',
    },
    size: {
      title: 'Size guide', sub: 'Measurements in centimetres, taken flat.',
      colSize: 'Size', colBust: 'Bust', colWaist: 'Waist', colHip: 'Hips',
      howTitle: 'How to measure', how1: 'Bust: at the fullest point, tape kept horizontal.',
      how2: 'Waist: at the narrowest point, without pulling.', how3: 'Hips: at the fullest point, feet together.',
      noteTitle: 'Between two sizes?', note: 'Take the larger — our cuts will only look better. Knits are worn with a light ease.',
      fitNote: 'Indicative measurements — each product page lists available sizes.',
    },
    faq: {
      title: 'Frequently asked', sub: 'The essentials, in few words.',
      cats: { orders: 'Orders', shipping: 'Shipping', returns: 'Returns', sizing: 'Sizing', payment: 'Payment', products: 'Products' },
      items: {
        orders: [
          { q: 'How do I place an order?', a: 'Add pieces to your bag, then follow the steps: contact, address, delivery, payment. No account needed.' },
          { q: 'Can I change my order?', a: 'If it has not been prepared yet, write to us right away — we will do our best.' },
        ],
        shipping: [
          { q: 'Where do you deliver?', a: 'Everywhere in Morocco. Timings shown at checkout are indicative and confirmed by e-mail.' },
          { q: 'What are the delivery fees?', a: '40 DH standard, free over 600 DH. Express delivery at 90 DH. Indicative timings.' },
        ],
        returns: [
          { q: 'How do I return a piece?', a: 'You have 7 days after receipt. The piece must be unworn, with its tags — see the Returns page.' },
          { q: 'Are returns paid?', a: 'Return shipping is at your expense, except for faulty items — exchange then offered free.' },
        ],
        sizing: [
          { q: 'How do I choose my size?', a: 'See the size guide: detailed measurements and advice. Between two sizes, take the larger.' },
          { q: 'Do your cuts run true?', a: 'Our cuts follow the guide; knits are worn with a light ease.' },
        ],
        payment: [
          { q: 'Can I pay on delivery?', a: 'Yes — cash on delivery is available across Morocco, with no extra fees.' },
          { q: 'Do you offer online payment?', a: 'Not yet. For now: cash on delivery or bank transfer (details sent after the order).' },
        ],
        products: [
          { q: 'Where do your materials come from?', a: 'Our materials are selected piece by piece; each product page details the exact composition.' },
          { q: 'Are all pieces in stock?', a: 'Each page lists available sizes; stock updates with every order.' },
        ],
      },
    },
    ship: {
      title: 'Shipping', intro: 'We deliver across Morocco with the same care we put into making a piece.',
      t1Title: 'Timings', t1Body: 'Standard delivery: 2 to 4 business days. Express delivery: 24 to 48 hours.',
      t2Title: 'Fees', t2Body: 'Standard: 40 DH — free over 600 DH. Express: 90 DH, whatever the order.',
      t3Title: 'Tracking', t3Body: 'A tracking link is e-mailed to you as soon as the parcel ships.',
      placeholder: 'Indicative timing — to be confirmed',
    },
    returns: {
      title: 'Returns & exchanges', intro: 'A piece that does not fit should never become a worry.',
      r1Title: 'Window', r1Body: 'You have 7 days after receipt to request a return or an exchange.',
      r2Title: 'Conditions', r2Body: 'The piece must be unworn, unwashed, with its original tags.',
      r3Title: 'Refund', r3Body: 'Once the piece is received and checked, the refund is issued within 5 business days.',
      exchTitle: 'Exchanges', exchBody: 'Need another size? Write to us — the exchange ships as soon as the first piece arrives.',
      noteTitle: 'Faulty item?', noteBody: 'Return fully covered, exchange prioritised.',
      placeholder: 'Indicative timing — to be confirmed',
    },
    footer: {
      shopCol: 'Shop', helpCol: 'Help', houseCol: 'The house', tagline: 'Soft elegance, across Morocco.',
      rights: '© MIORA Boutique — miora-boutique.com. All rights reserved.',
      paymentNote: 'Cash on delivery · Bank transfer',
    },
    notFound: { title: 'Page not found', sub: 'The link may have changed — the shop, however, is right here.', cta: 'Back home' },
  },

  ar: {
    common: {
      currency: 'درهم', addToBag: 'أضيفي إلى السلة', added: 'أُضيفت إلى السلة',
      viewAll: 'عرض الكل', new: 'جديد', signature: 'التوقيع',
      remove: 'إزالة', close: 'إغلاق', menu: 'القائمة',
      placeholderLabel: 'التصوير قريبًا',
      placeholderNote: 'مساحة مخصصة للتصوير الرسمي',
      loading: 'جارٍ التحميل…', free: 'مجانية', back: 'رجوع',
      continueShopping: 'متابعة التسوق', qty: 'الكمية', size: 'المقاس', color: 'اللون',
    },
    nav: { home: 'الرئيسية', shop: 'المتجر', about: 'عن ميورا', contact: 'اتصلي بنا', bag: 'السلة' },
    announce: 'التوصيل مجاني للطلبات فوق 600 درهم · الدفع عند الاستلام في جميع أنحاء المغرب',
    hero: {
      eyebrow: 'المجموعة الجديدة',
      line1: 'الأناقة،',
      line2: 'بهدوء.',
      sub: 'قطع أنثوية بانسدالٍ رقيق صُمّمت لتدوم — فساتين وحياكات وحرائر بتركيبة ألوان مهدّئة.',
      cta1: 'اكتشفي المجموعة', cta2: 'شاهدي الجديد',
      phLabel: 'الحملة — التصوير قريبًا', caption: 'الإصدار 01 — الأساسيات', scroll: 'مرّري',
    },
    home: {
      newCollection: { eyebrow: 'الاختيار', title: 'المجموعة الجديدة', sub: 'أربع قطع تفتح الموسم بألوان الدار.', cta: 'زيارة المتجر' },
      categories: { eyebrow: 'استكشفي', title: 'حسب الفئة' },
      newIn: { eyebrow: 'وصل حديثًا', title: 'الجديد', cta: 'عرض الكل' },
      editorial: {
        eyebrow: 'المجلة', title: 'طقوس الارتداء',
        p1: 'في ميورا، تُختار القطعة كما يُختار الصمت: بعناية. موادنا مدروسة بالمَلَمس، وقصّاتنا مدروسة بالحركة.',
        p2: 'كل مجموعة تُكتب ببطء، بتركيبة ألوان تُهدّئ — وتُلبس أبطأ.',
        cta: 'اقرئي حكايتنا', phLabel: 'التحرير — التصوير قريبًا', caption: 'الطقوس — الإصدار 02',
      },
      statement: { quote: 'الفخامة ليست صاخبة، بل تُعرف بالهدوء الذي تتركه.', author: 'ميورا' },
      instagram: { eyebrow: '@mioraboutique_', title: 'تابعوا الدار', sub: 'لمحات من الأتيليه، وصولات جديدة، ورسومات لم تُنشر.', cta: 'فتح إنستغرام', phLabel: 'إنستغرام — صور قريبًا' },
      newsletter: { title: 'أخبارنا إليك', sub: 'الوصولات الجديدة والإصدارات المحدودة، لا شيء آخر. بلا ضجيج.', ph: 'بريدك الإلكتروني', cta: 'اشتركي', ok: 'شكرًا — تم التسجيل.', err: 'حدث خطأ. حاولي مرة أخرى.' },
    },
    shop: {
      title: 'المتجر', sub: 'كل قطعة بطريقتها: اختاري، قارني، جربي.',
      count: 'قطعة', filters: 'التصفية', clearAll: 'مسح الكل',
      category: 'الفئة', size: 'المقاس', color: 'اللون', price: 'السعر', collection: 'المجموعة',
      maxPrice: 'أقصى سعر', sortBy: 'الترتيب', sortNew: 'الوصولات الجديدة', sortPriceAsc: 'السعر تصاعديًا', sortPriceDesc: 'السعر تنازليًا',
      empty: 'لا توجد قطعة مطابقة لهذه التصفية.', emptyCta: 'إعادة ضبط التصفية',
      openFilters: 'تصفية', apply: 'عرض النتائج',
    },
    product: {
      description: 'الوصف', details: 'التفاصيل والقماش', shippingInfo: 'التوصيل والإرجاع',
      chooseSize: 'اختاري مقاسك', alsoLike: 'قد يعجبك أيضًا', selectSizeFirst: 'اختاري المقاس أولًا',
      notFound: 'القطعة غير موجودة.', backToShop: 'العودة إلى المتجر',
      shippingBody: 'التوصيل القياسي 40 درهمًا، مجانًا فوق 600 درهم — مدة تقديرية من 2 إلى 4 أيام عمل. الإرجاع مقبول خلال 7 أيام دون ارتداء.',
      careBody: 'غسيل رقيق بماء بارد على الوجه الخلفي. كيّ خفيف من الداخل. النعومة تدوم عندما تُعامل بلطف.',
    },
    bag: {
      title: 'السلة', empty: 'سلتك فارغة',
      emptySub: 'تنتظر أول قطعة — الوصولات الجديدة وصلت للتو.',
      ctaShop: 'اكتشفي المتجر', subtotal: 'المجموع الفرعي', shipping: 'التوصيل', total: 'الإجمالي',
      checkout: 'إتمام الطلب', note: 'الدفع عند الاستلام متاح في جميع أنحاء المغرب.',
      freeNote: 'تبقّى {x} للتوصيل المجاني.',
    },
    checkout: {
      title: 'الطلب', sub: 'خمس خطوات هادئة، دون حساب.',
      stepContact: 'التواصل', stepShipping: 'العنوان', stepDelivery: 'التوصيل', stepPayment: 'الدفع', stepSummary: 'الملخص',
      f_name: 'الاسم الكامل', f_email: 'البريد الإلكتروني', f_phone: 'الهاتف', f_address: 'العنوان', f_city: 'المدينة', f_postal: 'الرمز البريدي',
      deliveryTitle: 'طريقة التوصيل', standard: 'قياسي', standardTime: '2 إلى 4 أيام عمل', standardDesc: '40 درهمًا — مجانًا فوق 600 درهم. مدة تقديرية.',
      express: 'سريع', expressTime: '24 إلى 48 ساعة', expressDesc: '90 درهمًا، في جميع أنحاء المغرب. مدة تقديرية.',
      paymentTitle: 'طريقة الدفع', cod: 'الدفع عند الاستلام', codDesc: 'ادفعي نقدًا عند الاستلام، دون رسوم.',
      transfer: 'تحويل بنكي', transferDesc: 'ستُرسل إليك بياناتنا البنكية عبر البريد الإلكتروني بعد الطلب.',
      summaryTitle: 'الملخص', placeOrder: 'تأكيد الطلب', sending: 'جارٍ الإرسال…',
      successTitle: 'شكرًا لك.', successSub: 'طلبك {n} مؤكد. سيصلك بريد بالملخص.',
      successNote: 'هذه نسخة تجريبية — لم يُحصَّل أي مبلغ.',
      backToShop: 'العودة إلى المتجر', errRequired: 'يرجى ملء هذا الحقل.', edit: 'تعديل',
      emptyBag: 'سلتك فارغة — أضيفي قطعة قبل إتمام الطلب.',
    },
    about: {
      eyebrow: 'الدار', title: 'ميورا، الأناقة الهادئة',
      lead: 'دار أزياء نسائية وُلدت من قناعة واحدة: النعومة شكل من القوة.',
      s1Title: 'فكرتنا', s1: 'تختار ميورا قطعًا لا تصرخ أبدًا — قصّات دقيقة، مواد رقيقة، وتركيبة ألوان تذكّر الأرض والندى. لا مواسم صاخبة، بل قطع تبقى.',
      s2Title: 'موادنا', s2: 'حرائر مغسولة، كريب انسيابي، حياكات محكمة: تُختار كل مادة بالملمس، ثم تُلبس أسابيع قبل اعتمادها.',
      s3Title: 'وعدنا', s3: 'سلاسل صغيرة، أسعار عادلة، وخدمة تجيب كصديقة — بالفرنسية والإنجليزية والعربية.',
      quote: '«لا نريد إلباس الجميع، بل إلباس من يحبّن الهدوء.»',
      valuesTitle: 'ما يوجهنا', v1t: 'النعومة', v1d: 'مواد وألوان تُهدّئ ولا تُتعب.',
      v2t: 'الدقة', v2d: 'قصّات لأجسام حقيقية، أُقرّت بتجارب حقيقية.',
      v3t: 'الاقتضاب', v3d: 'التفصيل يكتشفه من يُتابع النظر — لا من أول نظرة.',
      phLabel: 'الدار — التصوير قريبًا', phLabel2: 'الأتيليه — التصوير قريبًا',
    },
    contact: {
      title: 'اكتبي لنا', sub: 'سؤال عن مقاس أو طلب أو إرجاع؟ نجيب سريعًا وببساطة.',
      name: 'الاسم', email: 'البريد الإلكتروني', subject: 'الموضوع', message: 'الرسالة', send: 'إرسال الرسالة', ok: 'تم إرسال الرسالة — شكرًا.', err: 'حدث خطأ. حاولي مرة أخرى.',
      csTitle: 'خدمة العملاء', emailLabel: 'bonjour@miora-boutique.com', hoursLabel: 'أوقات العمل', hoursValue: 'الاثنين – السبت، 9 ص – 6 م',
      responseNote: '(أوقات تقديرية — للتأكيد)', socialLabel: 'شبكات التواصل',
    },
    size: {
      title: 'دليل المقاسات', sub: 'القياسات بالسنتيمتر، مأخوذة على سطح مستوٍ.',
      colSize: 'المقاس', colBust: 'محيط الصدر', colWaist: 'محيط الخصر', colHip: 'محيط الأرداف',
      howTitle: 'كيف تقيسين', how1: 'الصدر: عند أوسع نقطة، مع إبقاء الشريط أفقيًا.',
      how2: 'الخصر: عند أضيق نقطة، دون شد.', how3: 'الأرداف: عند أوسع نقطة، والقدمان معًا.',
      noteTitle: 'بين مقاسين؟', note: 'اختاري الأكبر — قصّاتنا ستبدو أجمل. الحياكات تُلبس براحة خفيفة.',
      fitNote: 'قياسات تقديرية — كل صفحة منتج تذكر المقاسات المتوفرة.',
    },
    faq: {
      title: 'أسئلة متكررة', sub: 'الأساسيات بكلمات قليلة.',
      cats: { orders: 'الطلبات', shipping: 'التوصيل', returns: 'الإرجاع', sizing: 'المقاسات', payment: 'الدفع', products: 'المنتجات' },
      items: {
        orders: [
          { q: 'كيف أُتمم طلبي؟', a: 'أضيفي القطع إلى السلة ثم اتبعي الخطوات: التواصل، العنوان، التوصيل، الدفع. لا حاجة لحساب.' },
          { q: 'هل يمكنني تعديل طلبي؟', a: 'إذا لم يُجهَّز بعد، اكتبي لنا فورًا وسنبذل وسعنا.' },
        ],
        shipping: [
          { q: 'أين توصلون؟', a: 'في جميع أنحاء المغرب. المدد المعروضة عند الطلب تقديرية ويُؤكَّدها البريد الإلكتروني.' },
          { q: 'ما هي رسوم التوصيل؟', a: '40 درهمًا قياسيًا، ومجاني فوق 600 درهم. التوصيل السريع 90 درهمًا. مدد تقديرية.' },
        ],
        returns: [
          { q: 'كيف أُرجع قطعة؟', a: 'لديك 7 أيام من الاستلام. يجب أن تكون القطعة غير مرتدية وببطاقاتها — انظري صفحة الإرجاع.' },
          { q: 'هل الإرجاع مجاني؟', a: 'رسوم الإرجاع على عهدتكما، ما عدا القطع المعيبة — فيُقدَّم التبادل مجانًا.' },
        ],
        sizing: [
          { q: 'كيف أختار مقاسي؟', a: 'انظري إلى دليل المقاسات: قياسات ونصائح مفصلة. بين مقاسين، اختاري الأكبر.' },
          { q: 'هل قصّاتكم مطابقة؟', a: 'قصّاتنا مطابقة للدليل؛ الحياكات تُلبس براحة خفيفة.' },
        ],
        payment: [
          { q: 'هل يمكنني الدفع عند الاستلام؟', a: 'نعم — الدفع عند الاستلام متاح في جميع أنحاء المغرب دون رسوم إضافية.' },
          { q: 'هل توفرون الدفع الإلكتروني؟', a: 'ليس بعد. حاليًا: الدفع عند الاستلام أو التحويل البنكي (تُرسل البيانات بعد الطلب).' },
        ],
        products: [
          { q: 'من أين موادكم؟', a: 'تُختار موادنا قطعة بقطعة؛ كل صفحة منتج توضح التركيبة بدقة.' },
          { q: 'هل كل القطع متوفرة؟', a: 'كل صفحة تذكر المقاسات المتوفرة؛ ويُحدَّث المخزون مع كل طلب.' },
        ],
      },
    },
    ship: {
      title: 'التوصيل', intro: 'نوصل في جميع أنحاء المغرب بالعناية نفسها التي نصنع بها القطعة.',
      t1Title: 'المدد', t1Body: 'التوصيل القياسي: 2 إلى 4 أيام عمل. السريع: 24 إلى 48 ساعة.',
      t2Title: 'الرسوم', t2Body: 'قياسي: 40 درهمًا — مجانًا فوق 600 درهم. سريع: 90 درهمًا لأي طلب.',
      t3Title: 'التتبع', t3Body: 'يُرسل رابط التتبع إلى بريدك فور شحن الطرد.',
      placeholder: 'مدة تقديرية — للتأكيد',
    },
    returns: {
      title: 'الإرجاع والتبادل', intro: 'القطعة التي لا تناسبك لا يجب أن تصبح همًّا.',
      r1Title: 'المدة', r1Body: 'لديك 7 أيام من الاستلام لطلب إرجاع أو تبادل.',
      r2Title: 'الشروط', r2Body: 'يجب أن تكون القطعة غير مرتدية وغير مغسولة وببطاقاتها الأصلية.',
      r3Title: 'الاسترداد', r3Body: 'بعد استلام القطعة وفحصها، يُرسل المبلغ خلال 5 أيام عمل.',
      exchTitle: 'التبادل', exchBody: 'تريدين مقاسًا آخر؟ اكتبي لنا — يُشحن التبادل فور استلام القطعة الأولى.',
      noteTitle: 'قطعة معيبة؟', noteBody: 'الإرجاع مجاني بالكامل، والتبادل على رأس الأولويات.',
      placeholder: 'مدة تقديرية — للتأكيد',
    },
    footer: {
      shopCol: 'المتجر', helpCol: 'المساعدة', houseCol: 'الدار', tagline: 'الأناقة الهادئة، في جميع أنحاء المغرب.',
      rights: '© ميورا بوتيك — miora-boutique.com. جميع الحقوق محفوظة.',
      paymentNote: 'الدفع عند الاستلام · تحويل بنكي',
    },
    notFound: { title: 'الصفحة غير موجودة', sub: 'ربما تغيّر الرابط — لكن المتجر ما يزال هنا.', cta: 'العودة إلى الرئيسية' },
  },
};
